/**
 * Emails allowed to view the admin dashboard (/dashboard).
 *
 * NOTE: this is a client-side convenience check only. Anyone can read this list
 * in the bundled JS, and a determined user can bypass the UI entirely. The real
 * protection must be Firestore security rules on the `orders` collection.
 */
const whitelistedUsers = [
  // FIXME(confirm): this was "neerajwadhwani43@gmail" (missing .com) and so
  // never matched. Corrected to the obvious intent — verify it's the right address.
  "neerajwadhwani43@gmail.com",
  "tarunwadhwani96@gmail.com",
  "yogitabajaj90@gmail.com",
];

export const isWhitelisted = (email) =>
  Boolean(email) && whitelistedUsers.includes(email.trim().toLowerCase());

export default whitelistedUsers;
